import 'semantic-ui-less/semantic.less';

import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { Provider } from "react-redux";
import "./styles/index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import "./polyfills/array-polyfill";
import { history } from "./helpers/history";
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import {QueryClientProvider} from "react-query";
import {queryClient} from "src/api/queryClient";

const QP = (QueryClientProvider as any);

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<QP client={queryClient}>
				<ToastContainer />
				<Router history={history}>
					<App />
				</Router>
			</QP>
		</Provider>
	</React.StrictMode>,
	document.getElementById("root")
);

reportWebVitals();

// https://github.com/Semantic-Org/example-github/blob/master/semantic/src/themes/github/globals/site.variables
// https://semantic-ui.com/usage/theming.html